import React from 'react';

const InnerLoader = (props) => {
    return (
        <div style={{ borderTop: "2px solid " + props.borderColor }} className={"loader me-2 d-inline-block"}></div>
    )
}

export default InnerLoader